import React from 'react';
import styles from "../components/Slide.module.sass";
import {Comment} from "./Comment";
import ReactFlipCard from 'reactjs-flip-card'

export const SLide = () => {
    return (
        <div className={styles.section__review__sliderWrap}>
            <div className={styles.section__review__slider}>
                <div className={styles.section__review__sliderColumn1}>
                    <Comment text={"Приятные консультанты, чистый магазин, приятная музыка, а главное большой выбор"}></Comment>
                    <Comment text={"Очень хороший магазин, можно подобрать" +
                        " одежду на любой вкус и большой размер. Приветливый" +
                        " грамотный персонал. Магазин понравился, рекомендую."}></Comment>
                    <Comment text={"Суперский магазин. Рекомендую тем кто не" +
                        " может найти подходящий размер. Для прекрасных дам."}></Comment>
                </div>
                <div className={styles.section__review__sliderColumn2}>
                    <Comment text={"Классный магазин: большой выбор одежды" +
                        " как женской, так и мужской. Большие размеры всегда" +
                        " трудно выбрать, а здесь без покупок не уйдёшь)) " +
                        "очень приятный вежливый персонал, всегда поможет с выбором"}></Comment>
                    <Comment text={"Отличный выбор одежды. Отзывчивый персонал. Помогли выбрать одежду и размер подобрать. Большой магазин есть где развернутся, раздевалки большие и удобные. Есть где посидеть детям, кофе вода конфетки! Рекомендую. "}></Comment>
                    <Comment text={"Отличный персонал, теплая приятная обстановка." +
                        " Угостили конфетами и кофе. Дружелюбные женщины. =)"}></Comment>
                </div>
            </div>
        </div>
    );
};
